import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 300px;
  padding: 20px;
  background: ${NeutralColors[0]};
  border-radius: ${({ theme }) => theme.borderRadius}px;
`;
